<template>
    <v-container class="app-container px-0">
        <h1>{{metaData.header}}</h1>
        <v-row class="mx-0 py-6">
            <v-col xs="12" md="4" v-for="(item, index) in regionsData" :key="index">
                <v-card :to="item.link" min-height="150px">
                    <v-card-title class="justify-center">{{ item.localName }}</v-card-title>
                    <v-card-text class="text-center">{{ $t('productsCount')}}: {{item.productsCount}}</v-card-text>
                    <v-card-actions class="justify-center">
                        <v-btn text color="orange" :to="item.path">{{ $t('goTo')}}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import GeoService from "../../../app-front/services/api/GeoService";

    export default {
        name: "RegionsList",
        data(){
            return {
                metaUrl: '/regions',
                regionsData: []
            }
        },
        methods: {
            getData() {
                GeoService.setLocale(this.$store.state.language.appLanguage);
                GeoService.getRegionsList()
                    .then(res=>{
                        this.regionsData = res.data;
                    }).catch(err=>console.log(err.response.data))
            }
        },
        created(){
            this.getData();
        }
    }
</script>

<style scoped>

</style>
